export default __webpack_public_path__ + "ce2a9891baf4b912e86fc43722ff92e1.png";